import { Grid } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CommonPageLayout } from 'src/components/common/CommonPageLayout'
import { useCustomerCtx } from 'src/hooks/context-hooks'
import { FrequenciesContainer } from 'src/screens/customer/services/frequencies/FrequenciesContainer'
import EquipmentMaintenanceTemplatesContainer from 'src/screens/customer/services/maintenances/EquipmentMaintenanceTemplatesContainer'
import LocalityMaintenanceTemplatesContainer from 'src/screens/customer/services/maintenances/LocalityMaintenanceTemplatesContainer'
import MaintenanceActiveLocalities from 'src/screens/customer/services/maintenances/MaintenanceActiveLocalities'
import { Padding } from 'src/styles/paddingComponent'

const ServicesPage = () => {
  const { t: translate } = useTranslation(['service', 'common'])
  const { customer } = useCustomerCtx()
  return (
    <CommonPageLayout titleSection={{ title: translate('services', { ns: 'service' }) }}>
      <Padding.pv8>
        <FrequenciesContainer />
      </Padding.pv8>
      <Padding.pv8>
        <Grid container display={'flex'} flexDirection={'row'} justifyContent={'space-evenly'} columnSpacing={2}>
          <Grid item xs={6}>
            <EquipmentMaintenanceTemplatesContainer customerId={customer.id} />
          </Grid>
          <Grid item xs={6}>
            <LocalityMaintenanceTemplatesContainer customerId={customer.id} />
          </Grid>
        </Grid>
      </Padding.pv8>
      <Padding.pv8>
        <MaintenanceActiveLocalities />
      </Padding.pv8>
    </CommonPageLayout>
  )
}

export default ServicesPage
